import { z } from 'zod';
/**
 * Điểm rủi ro trễ của một dự án — APM-AI-q (`plan-ai-features.md` mục 3).
 *
 * ## Điểm là của HỆ THỐNG, lời là của AI
 *
 * Con số ở đây tính bằng một hàm thuần trên chỉ báo đếm được, không qua model.
 * Đó không phải để tiết kiệm: một điểm rủi ro do model chấm thì mỗi lần hỏi ra
 * một số khác, không ai kiểm được, và không so được giữa hai dự án. Skill
 * `explain_delay_risk` chỉ **viết lời** cho ba lý do đứng đầu.
 *
 * ## Mỗi chỉ báo là một con số đếm được
 *
 * Không có chỉ báo nào là "cảm nhận của PM". Mọi giá trị dưới đây đọc ra được
 * từ `event_log` và state hiện tại, nên điểm tái dựng lại được cho **bất kỳ
 * ngày nào** — và đó là điều làm nó so được với kết cục thật.
 */
export const DelayRiskIndicators = z.object({
    /** Tuổi trung bình của việc đang làm dở, tính bằng ngày. Cao = việc mắc kẹt. */
    agingWipDays: z.number().nonnegative(),
    /** Tỉ lệ việc đang mở mà không có động tĩnh gì quá ngưỡng (0–1). */
    silentTaskRatio: z.number().min(0).max(1),
    /** Số lần đổi người mỗi tuần, trung bình 4 tuần gần nhất. */
    reassignsPerWeek: z.number().nonnegative(),
    /** Tỉ lệ việc đã xong mà giờ thực vượt ước lượng (0–1). */
    overrunRatio: z.number().min(0).max(1),
    /** Số yêu cầu thay đổi trong 2 tuần gần nhất. */
    changeRequests: z.number().int().nonnegative(),
    /** Tỉ lệ việc đang mở bị chặn (0–1). */
    blockedRatio: z.number().min(0).max(1),
    /** Tỉ lệ ngày nghỉ đã đăng ký của đội trong 4 tuần tới (0–1). */
    upcomingAbsenceRatio: z.number().min(0).max(1),
    /** Số người gánh quá nửa số việc đang mở. 1 = cả dự án phụ thuộc một người. */
    busFactor: z.number().int().nonnegative(),
});
export const DelayRiskReason = z.object({
    /** Khoá chỉ báo — giao diện tự dịch, nên đây không phải chuỗi hiển thị. */
    indicator: z.string(),
    /** Bao nhiêu điểm rủi ro đến từ chỉ báo này. */
    points: z.number().nonnegative(),
    /** Giá trị thô, để người đọc thấy con số chứ không chỉ thấy kết luận. */
    value: z.number(),
});
/**
 * Tên là `ProjectDelayRisk`, không phải `ProjectHealth`.
 *
 * `ProjectHealth` đã có ở `portfolio.ts` và nói một thứ khác: ba tín hiệu RAG
 * cho màn danh mục. Hai khái niệm khác nhau mang cùng một tên là cách chắc chắn
 * để ai đó đọc nhầm con số này thành con số kia.
 */
export const ProjectDelayRisk = z.object({
    projectId: z.uuid(),
    day: z.string(),
    /** 0 = lành, 100 = chắc chắn trễ. Cùng thang cho mọi dự án nên so được. */
    score: z.number().int().min(0).max(100),
    indicators: DelayRiskIndicators,
    /** Ba lý do nặng nhất, đã xếp hạng. Rỗng khi không chỉ báo nào xấu. */
    topReasons: z.array(DelayRiskReason).max(3),
});
//# sourceMappingURL=project-delay-risk.js.map